<template>
  <v-dialog align="center" max-width="800px" v-model="dialog" persistent>
    <v-card>
      <v-toolbar dense dark color="primary">
        <v-toolbar-title>
          Content Section Editor
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="Close()">
          <v-icon>
            mdi-close
          </v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="mt-5" v-if="item!=null">
        <v-form v-model="valid">
          <v-row>
            <v-col cols="12">
              <v-text-field required :rules="nameRules" label="Description" v-model="item.description">
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" v-if="item.type==2||item.type==3">
              <label> Click on the block to below to change media </label>
              <v-card flat >
                <imageContent :click="openfileTitleDialog" v-if="item.type==2 && showImage" :content="item" />
                <videoContent :click="openfileTitleDialog" v-if="item.type==3" :content="item" />
              </v-card>
            </v-col>
          </v-row>
          <v-row v-if="item.type == 1">
            <wysiwyg v-model="item.contentText" style="height:600px" />
          </v-row>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" :disabled="!valid" @click="submit()">Submit</v-btn>
      </v-card-actions>
    </v-card>
    <input accept="*" ref="FileBackGround" @change="uploadtitleImage" type="file" style="display: none" />
    <g-snackbar-alert ref="snackbarAlert" />

  </v-dialog>
</template>

<script>
  import Axios from "axios";
  import videoContent from "../components/video"
  import imageContent from "../components/image"

  export default {
    components: {
      imageContent,
      videoContent
    },
    data() {
      return {
        callback: null,
        dialog: false,
        item: {},
        controller: null,
        showImage: true,
        valid: false,
        acceptedVideoTypes: ["video/quicktime", "video/mp4"],
        acceptedImageTypes: ["image/png", "image/jpg", "image/jpeg"],
        nameRules: [
          v => !!v || 'Description is required',
        ],
      };
    },
    methods: {
      openfileTitleDialog() {
        let self = this;
        self.$refs.FileBackGround.value = null;
        self.$refs.FileBackGround.click();
      },
      uploadtitleImage(e) {
        let self = this;
        let file = e.target.files[0];
        const formData = new FormData();
        formData.append("file", file);
        console.log("[FILE]", file);
        if (self.item.type == 2) {
          //image 
          let foundfile = self.acceptedImageTypes.find(x => x == file.type)
          if (foundfile == null || foundfile == undefined) {
            self.$refs.snackbarAlert.show({
              colour: "error",
              text: "Please provide the correct image type (png,jpg or jpeg)"
            })
            return
          }
        }
        if (self.item.type == 3) {
          //video
          let foundfile = self.acceptedVideoTypes.find(x => x == file.type)
          if (foundfile == null || foundfile == undefined) {
            self.$refs.snackbarAlert.show({
              colour: "error",
              text: "please provide the correct video type (mp4 or mov)"
            })
            return
          }
        }
        self.showImage = false;
        const config = {
          headers: {
            "content-type": "multipart/form-data",
          },
        };
        let token = localStorage.getItem("access_token");
        Axios.defaults.headers.common["Authorization"] = "bearer " + token;
        Axios.post(
          process.env.VUE_APP_API + "SystemMedia",
          formData,
          config
        ).then((r) => {
          self.item.mediaId = r.data.data.id
          self.showImage = true;
          // self.controller[self.callback](self.item);
        });
      },
      open(item, controller, callback) {
        let self = this;
        console.log("open", item, callback);
        self.callback = callback;
        this.controller = this.get_controller(controller)
        self.item = item
        self.dialog = true;
      },
      submit() {
        let self = this;
        self.dialog = false;
        self.controller[self.callback](self.item);
      },
      Close() {
        let self = this
        self.dialog = false
      }
    },
  };
</script>